import { Media } from './media';
import { Program } from './program';
import { Role } from './user';

export enum SearchTypes {
  Program = 'program',
  Media = 'media',
  Role = 'role',
}

export type SearchResult = {
  tab_title: string;
  doc_type: SearchTypes;
  items: Program[] | Media[] | Role[];
};

export type RoleWithPrograms = {
  name: string;
  programs: Program[];
  UUID: string;
};
